export default class RaffleTicketsBlock {
    constructor(root) {
        this.root = root;
        this.tickets = document.querySelectorAll('.js-raffle-tickets-block-ticket');
        this.plus_buttons = document.querySelectorAll('.js-raffle-tickets-block-plus');
        this.minus_buttons = document.querySelectorAll('.js-raffle-tickets-block-minus');
        this.titles = document.querySelectorAll('.js-raffle-tickets-block-title');
        this.items = document.querySelectorAll('.js-raffle-tickets-block-items');
        this.purchase_buttons = document.querySelectorAll('.js-raffle-tickets-block-purchase');
        this.syncCart();

        window.addEventListener('cart-changed', (event) => {
            this.syncCart();
        });

        this.plus_buttons.forEach((plus_button) => {
            plus_button.addEventListener('click', (e) => {
                e.preventDefault();
                let total = plus_button.parentElement.querySelector('.js-raffle-tickets-block-item-total');
                let minus = plus_button.parentElement.querySelector('.js-raffle-tickets-block-minus');

                total.dataset.current = parseInt(total.dataset.current) + 1;
                total.innerHTML = total.dataset.current;
                minus.classList.remove('--disabled');

                if(total.dataset.current == total.dataset.max) {
                    plus_button.classList.add('--disabled');
                }

                window.theme.cart.add(total.dataset.id);

                this.updateTotals();
            });
        });

        this.minus_buttons.forEach((minus_button) => {
            minus_button.addEventListener('click', (e) => {
                e.preventDefault();
                let total = minus_button.parentElement.querySelector('.js-raffle-tickets-block-item-total');
                let plus = minus_button.parentElement.querySelector('.js-raffle-tickets-block-plus');

                total.dataset.current = parseInt(total.dataset.current) - 1;
                total.innerHTML = total.dataset.current;
                plus.classList.remove('--disabled');

                if(total.dataset.current == 0) {
                    minus_button.classList.add('--disabled');
                }

                window.theme.cart.remove(total.dataset.id);

                this.updateTotals();
            });
        });
    }

    updateTotals() {
        let num_total_tickets = 0;
        let has_arm = false;

        this.items.forEach((item) => {
            item.innerHTML = '';
        });

        this.tickets.forEach((ticket) => {
            let total = ticket.querySelector('.js-raffle-tickets-block-item-total');
            let current = parseInt(total.dataset.current);
            let title = total.dataset.title;
            let quantity = total.dataset.quantity;

            if(!quantity) {
                quantity = 0;

                if(current > 0) {
                    has_arm = true;
                }
            }

            num_total_tickets += quantity * current;

            if(current > 0) {
                this.items.forEach((item) => {
                    if(current > 1) {
                        item.insertAdjacentHTML('beforeend', `<p class="block-raffle-tickets__item">${title} (x${total.dataset.current})</p>`);
                    } else {
                        item.insertAdjacentHTML('beforeend', `<p class="block-raffle-tickets__item">${title}</p>`);
                    }
                });
            }
        });

        this.titles.forEach((title) => {
            if(num_total_tickets == 1) {
                title.innerHTML = '1 Lucky Ticket' + (has_arm ? ' + ?' : '');
            } else if(num_total_tickets == 0 && has_arm) {
                title.innerHTML = '? Tickets';
            } else if(num_total_tickets == 0) {
                title.innerHTML = 'Select Tickets';
            } else {
                title.innerHTML = `${num_total_tickets} Tickets` + (has_arm ? ' + ?' : '');
            }
        });

        this.purchase_buttons.forEach((purchase_button) => {
            if(num_total_tickets == 0 && has_arm == false) {
                purchase_button.classList.add('--disabled');
            } else {
                purchase_button.classList.remove('--disabled');
            }
        });
    }

    syncCart() {
        this.tickets.forEach((ticket) => {
            let total = ticket.querySelector('.js-raffle-tickets-block-item-total');
            let plus = ticket.querySelector('.js-raffle-tickets-block-plus');
            let minus = ticket.querySelector('.js-raffle-tickets-block-minus');
            let item = window.theme.cart.getItem(total.dataset.id);

            if(item?.count > 0) {
                total.dataset.current = item.count;
                total.innerHTML = item.count;
                minus.classList.remove('--disabled');

                if(total.dataset.current == total.dataset.max) {
                    plus.classList.add('--disabled');
                }
            } else {
                total.dataset.current = 0;
                total.innerHTML = 0;
                minus.classList.add('--disabled');
                plus.classList.remove('--disabled');
            }
        });

        this.updateTotals();
    }
}
